import * as AuditLogAction from "../actions/audit-log.action";

import { AuditLog, AuditType } from "@app/audit-log/models/audit-log-type.model";
import { ApiResultState, LoadingState, initialApiObjectState } from "@app/root-store/api-result.state";
import { createReducer, on } from "@ngrx/store";

export interface AuditLogStoreState {
    auditType: ApiResultState<{ [index: string]: AuditType }>;
    auditData: ApiResultState<AuditLog[]>;
}
export const initialAuditLogState: AuditLogStoreState = {
    auditData: initialApiObjectState<AuditLog[]>(),
    auditType: initialApiObjectState<{ [index: string]: AuditType }>(),
};
export const auditLogReducer = createReducer(
    initialAuditLogState,
    on(
        AuditLogAction.loadType,
        (state): AuditLogStoreState => ({
            ...state,
            auditType: {
                ...state.auditType,
                callState: LoadingState.loading,
            },
        })
    ),
    on(
        AuditLogAction.loadTypeSuccess,
        (state, { auditlogTypes }): AuditLogStoreState => ({
            ...state,
            auditType: {
                ...state.auditType,
                result: auditlogTypes,
                callState: LoadingState.loaded,
            },
        })
    ),

    // TODO: implement audit log store
    on(
        AuditLogAction.loadAuditLogSet.request,
        (state): AuditLogStoreState => ({
            ...state,
            auditData: {
                ...state.auditData,
                callState: LoadingState.loading,
            },
        })
    ),
    on(
        AuditLogAction.loadAuditLogSet.success,
        (state, { auditLogs }): AuditLogStoreState => ({
            ...state,
            auditData: {
                ...state.auditData,
                result: auditLogs,
                callState: LoadingState.loaded,
            },
        })
    ),
    on(
        AuditLogAction.loadAuditLogSet.failure,
        (state, { error }): AuditLogStoreState => ({
            ...state,
            auditData: {
                ...state.auditData,
                error,
            },
        })
    ),
    on(AuditLogAction.clearAuditState, (): AuditLogStoreState => initialAuditLogState),
    on(AuditLogAction.clearAuditDataState, state => ({ ...state, auditData: initialApiObjectState<AuditLog[]>([]) }))
);
